import { useEffect, useRef } from 'react';

export const useDidUpdateEffect = (callback, inputs) => {
  const didMountRef = useRef(false);
  useEffect(() => {
    if (didMountRef.current) {
      callback();
    } else {
      didMountRef.current = true;
    }
  }, inputs);
};
